"use client";
import React from "react";
import { Stack } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker, LocalizationProvider, PickerChangeHandlerContext } from "@mui/x-date-pickers-pro";
import { DateRangePickerProps } from "@mui/x-date-pickers-pro/DateRangePicker";
import { Dayjs } from "dayjs";
import "dayjs/locale/nl";
import { DateRange, DateRangeValidationError } from "@mui/x-date-pickers-pro/models";
import { MultiInputDateRangeField } from "@mui/x-date-pickers-pro/MultiInputDateRangeField";
import { PickerRangeValue } from "@mui/x-date-pickers/internals/models";
import { nlNL } from "@mui/x-date-pickers/locales";
import { WcIconButton } from "../WcButton/WcButton";
import { MdClose } from "react-icons/md";

export type WcDateRangePickerProps = DateRangePickerProps & {
  controlDisabled?: boolean;
  //@depricated: with should not be used here. if needed pass in via sx.
  width?: number | string;
  required?: boolean;
  error?: any;
  showCloseButton?: boolean;
  format?: string;
};

export const WcDateRangePicker = (props: WcDateRangePickerProps) => {
  const { controlDisabled, width, required, error, format, value, slots, sx, onChange, slotProps, showCloseButton, ...rest } = props;
  const [localValue, setLocalValue] = React.useState<PickerRangeValue>(value);
  const pickerValue: PickerRangeValue = localValue === null ? [null, null] : localValue;

  React.useEffect(() => {
    setLocalValue(value ?? null);
  }, [value]);

  const handleChange = (newValue: PickerRangeValue, context: PickerChangeHandlerContext<DateRangeValidationError>) => {
    if (newValue === null) {
      setLocalValue(null);
      onChange?.(null, context);
      return;
    }
    setLocalValue(newValue);
    const [start, end] = newValue;
    if (start && end && start.isValid() && end.isValid() && (start.isBefore(end) || start.isSame(end))) {
      onChange?.(newValue, context);
    }
  };

  const handleCloseChange = () => {
    setLocalValue(null);
    onChange(null, undefined);
  };
  return (
    <Stack direction={"row"} id="WcDateRangePicker">
      <LocalizationProvider
        adapterLocale={"nl"}
        dateAdapter={AdapterDayjs}
        localeText={nlNL.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <DateRangePicker
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
          disabled={controlDisabled}
          format={format ? format : "DD/MM/YYYY"}
          value={pickerValue}
          onChange={handleChange}
          slotProps={{
            ...slotProps,
          }}
          slots={{ field: MultiInputDateRangeField, ...slots }}
          {...rest}
        />
      </LocalizationProvider>
      {showCloseButton && (
        <WcIconButton
          size="small"
          onClick={() => {
            handleCloseChange();
          }}
        >
          <MdClose />
        </WcIconButton>
      )}
    </Stack>
  );
};

export default WcDateRangePicker;

export type WcDateRange = DateRange<Dayjs> | undefined;
export { MultiInputDateRangeField as WcMultiInputDateRangeField };
